import { UnauthenticatedService } from "../abstract/base.service";
import { SearchResult } from "@/models/search/searchresult";
import { LanguageDto } from "@/server/app.dtos";

export class SearchService extends UnauthenticatedService {
  Search(language: LanguageDto, keyword: string): Promise<SearchResult[]> {
    return this.Get<SearchResult[]>(
      `${this.baseUrl}api/Search?IdLanguage=` +
        language.idLanguage +
        `&Keyword=` +
        keyword
    );
  }
}
